import Image from 'components/Common/Image/Image'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import LineAngleRightBIcon from 'LuxKit/Icons/line/LineAngleRightBIcon'

const VISIT_US_IMAGE_ID = 'hamburguer-menu-bondi'

const VisitUsListItem = styled(ClickableListItem)`
  padding: ${rem(8)};
  min-height: ${rem(50)};
  border-radius: ${props => props.theme.borderRadius.L};
  border: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
`

const VisitUsImageContainer = styled.div`
  width: ${rem(48)};
  height: ${rem(48)};
  border-radius: ${props => props.theme.borderRadius.M};
  overflow: hidden;
`

interface Props {
  navItem: App.NavItem
  onNavigate: () => void
}

function NavBarHamburgerMenuVisitUsBanner(props: Props) {
  const { navItem, onNavigate } = props
  const intl = useIntl()

  const title = intl.formatMessage({
    id: 'ZPfWuAkLUz8xm49E-y4L',
    defaultMessage: 'Visit us in store',
  })
  const subtitle = intl.formatMessage({
    id: 'GscWjgDkQZlSHkS8ENrd',
    defaultMessage: 'Westfield Bondi',
  })

  return (
    <VisitUsListItem
      size="medium"
      startIcon={<VisitUsImageContainer>
        <Image
          id={VISIT_US_IMAGE_ID}
          dpr={2}
          fit="center"
          objectFit="cover"
        />
      </VisitUsImageContainer>}
      title={title}
      titleColour="normal-contrast"
      subtitle={subtitle}
      href={navItem.href}
      to={navItem.to}
      onClick={onNavigate}
      rel={navItem.target === '_blank' ? 'noopener noreferrer' : undefined}
      target={navItem.target}
      endIcon={<LineAngleRightBIcon />}
    />
  )
}

export default NavBarHamburgerMenuVisitUsBanner
